import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import brandLockupStacked from '../../../../asset/logo/lockup-stacked-color.svg';
import { mockStudentStorage } from '../mockStudentStorage';
import { INTER, NAVY, SLATE, yellowButtonSx } from '../studentStyles';

export default function StudentLogin() {
    const history = useHistory();
    const [name, setName] = React.useState(() => mockStudentStorage.getItem('studentName') || 'Maya');
    return <Box sx={{ maxWidth: 430, mx: 'auto', px: 3, py: 8 }}>
        <Stack component="form" spacing={3} onSubmit={(event: React.FormEvent) => {
            event.preventDefault();
            mockStudentStorage.setItem('studentName', name.trim());
            history.replace('/mockup/v2/student');
        }}>
            <Box component="img" src={brandLockupStacked} alt="VerbaSchola" sx={{ height: 96, mx: 'auto' }} />
            <Typography component="h1" sx={{ fontFamily: INTER, color: NAVY, fontSize: 24 }}>Student preview</Typography>
            <Typography sx={{ fontFamily: INTER, color: SLATE }}>Explore with sample lessons and fabricated data. No account is needed.</Typography>
            <TextField label="Your name" value={name} onChange={event => setName(event.target.value)} inputProps={{ maxLength: 40 }} />
            <Button type="submit" disabled={!name.trim()} sx={yellowButtonSx}>Open student preview</Button>
        </Stack>
    </Box>;
}
